import React from "react";
import "./FeaturedCategories.css";
import seasonal from "../assets/img/categories/specialty-and-seasonal.png";
import caffeineFree from "../assets/img/categories/caffeine-free-teaspremium.png";
import matcha from "../assets/img/categories/matcha-teapremium.png";
import bestSellers from "../assets/img/categories/best-sellerspremium.png";
import { Link } from "react-router-dom";

function FeaturedCategories() {
  return (
    // <div className="container d-flex flex-column justify-content-center align-items-center py-5">
    <div className="mt-3">
      <div className="row justify-content-center gx-4">
        <Link to={"/category/blacktea"} className="col-6 col-lg-3">
          <div className="mb-md-4 mb-sm-4 position-relative img-hover pointer img-cat-container">
            <p className="position-absolute top-50 start-50 translate-middle text-white text-center fs-4 fw-bold text-shadow">
              Specialty & Seasonal Teas
            </p>
            <img src={seasonal} alt="seasonal" className="img-fluid img-cat" />
          </div>
        </Link>
        <Link to={"/category/greentea"} className="col-6 col-lg-3">
          <div className="mb-md-4 mb-sm-4 position-relative img-hover pointer img-cat-container">
            <p className="position-absolute top-50 start-50 translate-middle text-white text-center fs-4 fw-bold text-shadow">
              Caffeine-Free Teas
            </p>
            <img
              src={caffeineFree}
              alt="caffeineFree"
              className="img-fluid img-cat"
            />
          </div>
        </Link>
        <Link to={"/category/herbaltea"} className="col-6 col-lg-3">
          <div className="position-relative img-hover pointer img-cat-container">
            <p className="position-absolute top-50 start-50 translate-middle text-white text-center fs-4 fw-bold text-shadow">
              Matcha Tea
            </p>
            <img src={matcha} alt="matcha" className="img-fluid img-cat" />
          </div>
        </Link>
        <Link to={"/products/sale"} className="col-6 col-lg-3">
          <div className="position-relative img-hover pointer img-cat-container">
            <p className="position-absolute top-50 start-50 translate-middle text-white text-center fs-4 fw-bold text-shadow">
              Best Sellers
            </p>
            <img src={bestSellers} alt="bestSellers" className="img-fluid" />
          </div>
        </Link>
      </div>
    </div>
    /* </div> */
  );
}

export default FeaturedCategories;
